import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../campaigns/assets/images/application-success.svg'
import _imports_1 from '../../campaigns/assets/images/danger-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-434813cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "success-image",
    src: _imports_0
  }),
  /*#__PURE__*/_createTextVNode(" Payment information has been validated ")
], -1))
const _hoisted_3 = { class: "p-d-flex" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "success-image",
    src: _imports_1
  }),
  /*#__PURE__*/_createTextVNode(" Payment information needs to be validated ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "This will be done through our payment partner Gigapay.", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "success-image",
    src: _imports_1
  }),
  /*#__PURE__*/_createTextVNode(" An invitation to Gigapay has been sent to your inbox ")
], -1))
const _hoisted_7 = {
  key: 1,
  class: "add-info"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($props.validated && !$props.isCreator)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", {
              class: _normalizeClass(["info", !$props.isCreator ? 'info2' : ''])
            }, "If you need to update your payment details then change info here.", 2),
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('changeInfo'))),
              class: "change-info"
            }, "CHANGE INFO")
          ])
        ]))
      : _createCommentVNode("", true),
    (!$props.validated && !$props.gigapayUser?.created_at)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass($props.isCreator ? 'creator p-col-11' : '')
        }, [
          _hoisted_4,
          _createElementVNode("div", {
            class: _normalizeClass(["p-d-flex", $props.isCreator ? 'p-justify-between btn-creator' : ''])
          }, [
            _createElementVNode("p", {
              class: _normalizeClass(["info", !$props.isCreator ? 'info2' : ''])
            }, [
              _createTextVNode(" Please validate your information here to continue with your campaign. "),
              _hoisted_5
            ], 2),
            _createElementVNode("div", {
              class: "add-info",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('addInfo')))
            }, "ADD INFO")
          ], 2)
        ], 2))
      : _createCommentVNode("", true),
    (!$props.gigapayUser?.verified_at && $props.gigapayUser?.notified_at)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass($props.isCreator ? 'creator p-col-11' : '')
        }, [
          _hoisted_6,
          _createElementVNode("div", {
            class: _normalizeClass(["p-d-flex", $props.isCreator ? 'p-justify-between btn-creator' : ''])
          }, [
            _createElementVNode("p", {
              class: _normalizeClass(["info", !$props.isCreator ? 'info2' : ''])
            }, " Please accept this invitation to receive payments in the future ", 2),
            (!$props.alredyInvited)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "add-info",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('sendAgain')))
                }, "Send again"))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString($props.alredyInvited), 1))
          ], 2)
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}